<h3 *ngIf="isLoading && !searchResults" [innerHTML]="loadingMessage"></h3>
<h3 *ngIf="searchResults && searchResults.TotalMatching>0" [innerHTML]="searchResults.ResultFoundMessage"></h3>
<h3 *ngIf="searchResults && searchResults.TotalMatching==0" [innerHTML]="searchResults.NoResultMessage"></h3>

<div class="swapa-body" *ngIf="searchResults">
    <div class="row justify-content-end align-items-center">
        <div class="col-12 col-md-auto w-25">
            <label class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <div class="swapa-search">
                        </div>
                    </span>
                </div>
                <input type="text"
                       [(ngModel)]="searchText"
                       class="form-control"
                       name="txtSearch"
                       #txtSearch
                       (keydown.enter)="performTextSearch($event)"
                       placeholder="Search Videos">
            </label>
        </div>
    </div>
    <article class="row" *ngFor="let article of searchResults.Items">
        <div class="col-12 col-md-4 mb-2 mb-md-0">
            <div class="thumbnail">
                <img class="cover"
                     src="{{article.ImagePath}}"
                     alt=""
                     width="100%"
                     height="200" />
                <a href="" data-toggle="modal"
                    data-target="#modal-playvideo"
                     id="openModalPopup"
                    #openModalPopup
                    (click)="showModalPopup(article.VideoUrl)" title="Click Here">
                    <span class="play-icon"></span>
                </a>
            </div>
        </div>
        <div class="col-12 col-md">
            <a href="{{article.Url}}" target="_self">
                <h3 [innerHTML]="article.NewsTitle">
                </h3>
            </a>
            <a>{{article.NewsDate}}</a>
            <span *ngIf="article.Categories && article.Categories.length>0"> | </span>
            <ng-container *ngFor="let category of article.Categories; let first = first; let last = last;">
                <a>{{category.Name}}</a><span *ngIf="!last">, </span>
            </ng-container>
            <p [innerHTML]="article.SummaryText">
            </p>
        </div>
    </article>
</div>

<!-- pagination -->
<div *ngIf="searchResults && searchResults.Items?.length>0 && searchResults.TotalMatching > pageSize" class="row justify-content-center justify-content-md-between align-items-center">
    <div class="col-12 col-md-5 text-left">
        <span>Showing {{endIndex}} of {{ searchResults.TotalMatching }} results</span>
    </div>
    <div class="col-12 col-md-5 text-center" style="z-index:99999;">
        <ngb-pagination [collectionSize]="searchResults.TotalMatching" [(page)]="page" [pageSize]="pageSize" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
        </ngb-pagination>
    </div>
    <div class="col-12 col-md-2 text-right">
        <p *ngIf="isLoading">Please wait...</p>
    </div>
</div>

<div *ngIf="searchResults && searchResults.Items?.length>0" class="swapa-top-tocshortcut text-right text-nonselectable">
    <a class="anchor-scroll btn btn-sm btn-primary ml-auto p-1 mb-2" href="#topofbody"> ↑ Back To Top </a>
</div>